import { render, staticRenderFns } from "./TableTr.vue?vue&type=template&id=bd342bc4&scoped=true"
import script from "./TableTr.vue?vue&type=script&lang=js"
export * from "./TableTr.vue?vue&type=script&lang=js"
import style0 from "./TableTr.vue?vue&type=style&index=0&id=bd342bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd342bc4",
  null
  
)

export default component.exports